module.exports = __webpack_public_path__ + "static/img/hu.ac606833.svg";